// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/lib/loader.js!./_toolbox_margin_padding.scss");
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = require("!../../../node_modules/vue-style-loader/lib/addStylesClient.js")("2f786ece", content, true, {});


//////////////////
// WEBPACK FOOTER
// ./src/assets/scss/_toolbox_margin_padding.scss
// module id = 9
// module chunks = 0